import { useState, useCallback } from "react";
import { DealerContextProps } from "./context";
import { Dealer, CoopInfo } from "@/interfaces";
import { CartHelper } from "@/helpers";

export const useDealerContextController = (): DealerContextProps => {
  const [dealerValue, setDealerValue] = useState<Dealer | undefined>();
  const [coopInfoValue, setCoopInfoValue] = useState<CoopInfo | undefined>();

  const setDealer = useCallback(
    (dealer?: Dealer) => {
      // Different dealer => any cached per-mediaId rates from the previous dealer are now
      // potentially wrong (rates are scoped per masterDealerId). Drop the cache so the
      // next recalculateCoop fetches fresh rates for this dealer.
      CartHelper.clearMediaIdRateCache();
      setDealerValue(dealer);
    },
    [setDealerValue]
  );

  const setCoopInfo = useCallback(
    (coopInfo?: CoopInfo) => {
      setCoopInfoValue(coopInfo);
    },
    [setCoopInfoValue]
  );

  const setNewSession = useCallback(() => {
    CartHelper.clearMediaIdRateCache();
    setDealerValue(undefined);
    setCoopInfoValue(undefined);
  }, [setDealerValue, setCoopInfoValue]);

  return {
    dealer: dealerValue,
    setDealer,
    coopInfo: coopInfoValue,
    setCoopInfo,
    setNewSession,
  };
};
